/** Shared formatting + status vocabulary for the HR screens. */

/** Staff records are `admins`; the display name falls back the same way the API does. */
export function staffName(admin: any): string {
  if (!admin) return "—";
  const full = [admin.firstname, admin.lastname].filter(Boolean).join(" ").trim();
  return admin.user?.name || full || admin.staff_no || "—";
}

export function fmtDate(iso?: string | null): string {
  if (!iso) return "—";
  const d = new Date(iso);
  return isNaN(d.getTime())
    ? String(iso)
    : d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
}

/** "08:30:00" or an ISO datetime → "08:30". */
export function fmtTime(v?: string | null): string {
  if (!v) return "—";
  const m = String(v).match(/(\d{2}):(\d{2})/);
  return m ? `${m[1]}:${m[2]}` : String(v);
}

/** Value for a <input type="time">, or "" when unset. */
export function timeInput(v?: string | null): string {
  if (!v) return "";
  const m = String(v).match(/(\d{2}):(\d{2})/);
  return m ? `${m[1]}:${m[2]}` : "";
}

export const todayIso = () => new Date().toISOString().slice(0, 10);

/** First and last day of the month a date falls in, as ISO dates. */
export function monthRange(d: Date = new Date()) {
  const from = new Date(d.getFullYear(), d.getMonth(), 1);
  const to = new Date(d.getFullYear(), d.getMonth() + 1, 0);
  const iso = (x: Date) =>
    `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, "0")}-${String(x.getDate()).padStart(2, "0")}`;
  return { from: iso(from), to: iso(to) };
}

export const ATTENDANCE_STATUSES = [
  "present",
  "late",
  "absent",
  "leave",
  "holiday",
  "weekend",
] as const;

export function attendanceColor(status?: string): string {
  switch (String(status ?? "").toLowerCase()) {
    case "present": return "bg-green-100 text-green-800 border-green-200";
    case "late":    return "bg-amber-100 text-amber-800 border-amber-200";
    case "absent":  return "bg-red-100 text-red-800 border-red-200";
    case "leave":   return "bg-sky-100 text-sky-800 border-sky-200";
    case "holiday": return "bg-violet-100 text-violet-800 border-violet-200";
    case "weekend": return "bg-gray-100 text-gray-600 border-gray-200";
    default:        return "bg-gray-100 text-gray-600 border-gray-200";
  }
}

export function leaveColor(status?: string): string {
  switch (String(status ?? "").toLowerCase()) {
    case "approved": return "bg-green-100 text-green-800 border-green-200";
    case "rejected": return "bg-red-100 text-red-800 border-red-200";
    case "pending":  return "bg-amber-100 text-amber-800 border-amber-200";
    case "cancelled": return "bg-gray-100 text-gray-600 border-gray-200";
    default:         return "bg-gray-100 text-gray-600 border-gray-200";
  }
}

/** Minutes → "1h 20m", for lateness and hours worked. */
export function fmtMinutes(mins?: number | null): string {
  const m = Number(mins ?? 0);
  if (!m) return "—";
  const h = Math.floor(m / 60);
  const r = m % 60;
  return h ? `${h}h${r ? ` ${r}m` : ""}` : `${r}m`;
}

export function errMsg(err: any): string {
  return err?.data?.message || err?.data?.error || err?.error || err?.message || "Something went wrong";
}
